// Lucide icon: arrow-up (https://lucide.dev/icons/arrow-up)
import { ArrowUp } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconPointerUp = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ArrowUp />
    </IconComponentStyled>
  )
}
